import { testimonials } from "@/mocks/testimonials";

export default function TestimonialSection() {
  return (
    <section className="border-y border-background-800 bg-background-900/60">
      <div className="mx-auto w-full max-w-content px-4 py-14 md:px-6 md:py-20">
        <div className="text-center">
          <p className="text-xs tracking-[0.3em] text-primary-400">READER NOTES</p>
          <h2 className="mt-3 font-heading text-2xl font-bold text-foreground-50 md:text-3xl">读者留在页脚的批注</h2>
          <p className="mx-auto mt-3 max-w-2xl text-sm leading-relaxed text-foreground-400">
            这些留言来自订阅读者的回信。我们把它们保留下来，因为档案是写给愿意认真读的人看的。
          </p>
        </div>

        <div className="mt-10 grid grid-cols-1 gap-5 md:grid-cols-2 lg:grid-cols-3">
          {testimonials.map((item, index) => (
            <figure
              key={item.name}
              className="flex h-full flex-col rounded-lg border border-background-800 bg-background-950 p-5"
            >
              <i className="ri-double-quotes-l text-2xl text-primary-500/60" />
              <blockquote className="mt-3 flex-1 text-sm leading-relaxed text-foreground-300">
                {item.content}
              </blockquote>
              <figcaption className="mt-5 flex items-center gap-3 border-t border-background-800 pt-4">
                <span
                  className={`flex h-10 w-10 items-center justify-center rounded-full font-heading text-sm font-bold ${
                    index % 2 === 0
                      ? "bg-primary-500/15 text-primary-300"
                      : "bg-secondary-500/15 text-secondary-300"
                  }`}
                >
                  {item.name.slice(0, 1)}
                </span>
                <span className="flex flex-col">
                  <span className="text-sm font-medium text-foreground-100">{item.name}</span>
                  <span className="text-xs text-foreground-500">{item.role}</span>
                </span>
              </figcaption>
            </figure>
          ))}
        </div>
      </div>
    </section>
  );
}